import {UserProfile} from "./user-profile";

export enum TicketStatus{
    open,
    close
}
export enum TicketType{
    change,
    cancel,
    unspecified
}
export class Ticket {
    Id : string='';
    Reference :string='';
    Status: string  = "0";
    TicketType : string ="0";
    Note : string ='';

    CreateAt: Date = new Date();
    CreatedByUserName:string='';
    CreatedBySub:string='';
    CreatedByName:string='';

    LastUpdatedAt:Date= new Date();
    LastUpdatedByUserName:string='';
    LastUpdatedBySub:string='';
    LastUpdatedByName:string='';

    constructor(init?: Partial<Ticket>) {
        Object.assign(this, init);
    }
}
